<template>
  <div :class="['cbg-auth__dropdown', { 'cbg-auth__dropdown_open': expanded, 'cbg-auth__dropdown_locked': selectedValue }]" ref="dropdown" @click.prevent="toggleDropdown">
    <input ref="dropdownInput" class="cbg-auth__dropdown-input" autocomplete="off" :readonly="!withSearch" type="text" :value="currentValue" placeholder=" " :id="dropdownName" :name="dropdownName" @input="handleInput" />
    <label class="cbg-auth__dropdown-label" :for="dropdownName">{{ dropdownName }}</label>
    <div v-if="expanded" class="cbg-auth__dropdown-content">
      <p v-if="!filteredOptions.length" class="cbg-auth__dropdown-message">Nothing found. Please make sure that the entered details are correct.</p>
      <ul v-else class="cbg-auth__dropdown-list">
        <li class="cbg-auth__dropdown-item" v-for="(option, index) in filteredOptions" :key="index" @click="selectValue(option.code)">
          <img v-if="option.region" :src="getImageSource(option.code)" class="cbg-auth__dropdown-item__ico" :alt="option.name" />
          <span class="cbg-auth__dropdown-item__text">{{ option.name }}</span>
        </li>
      </ul>
    </div>
    <button class="cbg-auth__dropdown-button" type="button">
      <Svg class-name="cbg-auth__dropdown-button__ico" icon-id="#arrow-down"/>
    </button>
  </div>
</template>

<script>
import Svg from "@/components/global/Svg.vue";
export default {
  name: 'Dropdown',
  components: { Svg },
  props: {
    dropdownName: String,
    modelValue: String,
    options: Array,
    withSearch: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      expanded: false,
      selectedValue: this.modelValue,
      searchQuery: '',
    };
  },
  computed: {
    currentLabel() {
      const { name } = this.options.find((item) => item.code === this.selectedValue) || {};
      return name || '';
    },
    filteredOptions() {
      const lowerSearchQuery = this.searchQuery.toLowerCase();
      return this.options.filter(option => option.name.toLowerCase().includes(lowerSearchQuery));
    },
    currentValue() {
      return this.withSearch ? (this.expanded ? this.searchQuery : this.currentLabel) : this.currentLabel;
    },
  },
  watch: {
    modelValue: function(newValue) {
      this.selectedValue = newValue;
      this.$emit('update:modelValue', newValue);
    }
  },
  methods: {
    toggleDropdown() {
      this.expanded = !this.expanded;
      const methodName = this.expanded ? 'addEventListener' : 'removeEventListener';
      document[methodName]('click', this.handleOutsideClick);

      if (this.expanded) {
        this.$refs.dropdownInput?.focus();
      } else {
        this.searchQuery = '';
        this.$refs.dropdownInput?.blur();
      }
    },

    selectValue(value) {
      this.selectedValue = value;
      this.$emit('update:modelValue', value);
      this.toggleDropdown();
    },

    handleOutsideClick(event) {
      if (!this.$refs.dropdown?.contains(event.target)) {
        this.toggleDropdown();
      }
    },

    handleInput(event) {
      this.searchQuery = event.target.value;
    },

    getImageSource(code) {
      try {
        return require(`@/assets/images/countries/${code}.svg`);
      } catch (error) {
        return require('@/assets/images/countries/default.svg');
      }
    },
  },
};
</script>